// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "microsite_page".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "microsite_page" table (1:1 with a DB row, on the wire). */
export const micrositePageAtomSchema = z.object({
    id: z.string(),
    micrositeId: z.string(),
    organizationId: z.string(),
    path: z.string(),
    title: z.string(),
    seo: z.unknown(),
    blocks: z.unknown(),
    order: z.number(),
    isSystem: z.boolean(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=micrositePage.js.map